import { render, staticRenderFns } from "./ColorPalettePicto.vue?vue&type=template&id=f5f478c8&"
import script from "./ColorPalettePicto.vue?vue&type=script&lang=js&"
export * from "./ColorPalettePicto.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalettePicto.vue?vue&type=style&index=0&id=f5f478c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports